import {
  LocalizationLanguage,
  QuestionConfigDetailDto,
} from "@green0meter/api-client";
import { create } from "zustand";

type QuestionEditorStore = {
  language: LocalizationLanguage;
  setLanguage: (language: LocalizationLanguage) => void;
  isRequired: boolean;
  setIsRequired: (isRequired: boolean) => void;
  newQuestionConfig?: QuestionConfigDetailDto;
  setNewQuestionConfig: (config: QuestionConfigDetailDto) => void;
};

export const useQuestionEditorStore = create<QuestionEditorStore>((set) => ({
  language: LocalizationLanguage.EN,
  setLanguage: (language: LocalizationLanguage): void => set({ language }),
  isRequired: false,
  setIsRequired: (isRequired: boolean): void => set({ isRequired }),
  newQuestionConfig: undefined,
  setNewQuestionConfig: (config: QuestionConfigDetailDto): void =>
    set({ newQuestionConfig: config }),
}));
